/** The release flag that picks the durable chat adapter over the request-bound one. */
import { FeatureFlags } from '@jms/model';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';

/** Release flag for the durable runtime: off means the request-bound path serves unchanged. */
export function isDurableRunsEnabled(): boolean {

  return ConfigService.environment?.featureFlags?.[FeatureFlags.AIDurableRuns] === true;
}
